<template>
  <b-card class="top-languages">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <p class="mb-0">
        <span class="top-languages--title" :class="isDarkMode ? 'dark' : ''"
          >Top Languages</span
        >
        <span class="top-languages--sub-title" :class="isDarkMode ? 'dark' : ''"
          >Most language translated</span
        >
      </p>
      <b-dropdown
        id="dropdown-1"
        class="top-languages--more-vertical"
        variant="light"
      >
        <template #button-content>
          <b-icon
            icon="three-dots-vertical"
            id="popover-button-variant"
            class="d-block cursor-pointer"
          />
        </template>
        <b-dropdown-item v-on:click="exportToCsv()">Export</b-dropdown-item>
      </b-dropdown>
    </div>
    <b-list-group v-if="topLanguagesData && topLanguagesData.length">
      <b-list-group-item
        class="d-flex justify-content-between align-items-center"
        v-for="item in topLanguagesData"
        :key="item.language"
      >
        <div class="d-flex align-items-start">
          <LanguageCode :languageCode="item.language_code" />
          <span class="d-inline-block ml-3">
            <span
              class="top-languages--item-title"
              :class="isDarkMode ? 'dark' : ''"
              >{{ item.language }}</span
            >
            <span
              class="top-languages--item-sub-title"
              :class="isDarkMode ? 'dark' : ''"
              >{{ formatNumber(item.count) }}
              {{ item.count > 1 ? "Translations" : "Translation" }}</span
            >
          </span>
        </div>
        <span
          class="top-languages--percentage"
          :class="isDarkMode ? 'dark' : ''"
          >{{ item.percentage }}%</span
        >
      </b-list-group-item>
    </b-list-group>
    <p v-else class="text-center pt-3">No Data Found</p>
  </b-card>
</template>

<script>
import formatter from "../../../mixins/formatter";
import LanguageCode from "../../common/LanguageCode.vue";
import json2csv from "json2csv";

export default {
  name: "TopLanguages",
  mixins: [formatter],
  props: {
    topLanguagesData: Array,
    isDarkMode: Boolean,
  },
  data() {
    return {};
  },
  components: {
    LanguageCode,
  },
  methods: {
    exportToCsv() {
      try {
        const opts = { fields: ["Language", "Translations", "Percentage"] };
        const csvData = [];
        if (this.topLanguagesData && this.topLanguagesData.length > 0) {
          this.topLanguagesData.map((value) => {
            csvData.push({
              Language: value.language,
              Translations: value.count,
              Percentage: `${value.percentage}%`,
            });
          });
        }

        const csv = json2csv.parse(csvData, opts);
        const blob = new Blob([csv], { type: "text/csv" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "Top-Language.csv";
        link.click();
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss">
.top-languages {
  &.card {
    height: 614px;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 0%), 0 6px 20px 0 rgb(0 0 0 / 12%);
    border-radius: 1rem;
    margin-bottom: 0;
    & .card-body {
      height: 100%;
    }
    & .list-group {
      height: calc(100% - 50px);
      overflow-y: auto;
    }
  }
  &--title {
    font-size: 1.125rem;
    text-align: left;
    color: #333843;
    font-weight: 600;
    margin-bottom: 0;
    display: block;
    &.dark {
      color: #b2b9bf !important;
    }
  }
  &--sub-title {
    text-align: left;
    font-size: 0.875rem;
    color: #727a90;
    font-weight: 500;
    margin-bottom: 0 !important;
    display: block;
    &.dark {
      color: #b2b9bf !important;
    }
  }
  &--percentage {
    color: #006c64;
    background: #eafffe;
    padding: 0.5rem;
    font-weight: 600;
    border-radius: 6px;
  }
  &--item-title {
    color: #0c0d0f;
    font-weight: 500;
    font-size: 0.875rem;
    display: block;
    &.dark {
      color: #b2b9bf !important;
    }
  }
  &--item-sub-title {
    color: #727a90;
    font-weight: 400;
    font-size: 0.75rem;
    display: block;
    &.dark {
      color: #b2b9bf !important;
    }
  }
  & .list-group-item {
    border: none;
    padding: 0.75rem;
  }
  &--more-vertical {
    &.show {
      & .dropdown-toggle {
        background-color: transparent !important;
        color: #6b7980;
        border: none;
        padding: 0;
      }
    }
    & .dropdown-toggle {
      background-color: transparent !important;
      color: #6b7980;
      border: none;
      padding: 0;
      &:active,
      &.active {
        background-color: transparent !important;
        color: #6b7980 !important;
        border: none !important;
      }
      &::after {
        display: none;
      }
    }
    & .dropdown-menu {
      padding: 0;
    }
  }
}
</style>
